import i18n from "../i18n";

export const ERROR_MESSAGE = (error) => {
  const error_message = {
    INVALID_CREDENTIALS_ERROR: i18n.t("auth.login.errors.invalidCredentials"),
    VERIFICATION_TOKEN_INVALID_ERROR: i18n.t("auth.login.errors.invalidToken"),
    MISSING_COMPANY_ERROR: i18n.t("auth.login.errors.missingCompany"),
  };
  return error_message[error];
};
